export default "__VITE_ASSET__DZUwfJUs__"